<template>
    <div class="organizationalDevelopment">
        <div class="card-box">
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <div class="fisthang">
                            <el-form
                                :inline="true"
                                :model="searchlist"
                                class="demo-form-inline"
                                size="mini"
                            >
                                <el-form-item label="名称:" style="margin:0 10 0 0;">
                                    <el-input
                                        v-model="searchlist.proofOfEstablishmentName"
                                        placeholder="请输入名称"
                                        style="width:200px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="发布日期:" style="margin:0 30 0 0;">
                                    <el-date-picker
                                        v-model="searchlist.publicTime"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="searchlistdata">查询</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="info" @click="searchlistReset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="three">
                            <el-button
                                type="primary"
                                size="mini"
                                @click="showDialogForm(0,'add')"
                            >新增</el-button>
                        </div>
                        <!-- 表格盒子 -->
                        <div class="table_card">
                            <el-table
                                :data="tableData"
                                :header-cell-style="{ background: '#f8fafa' }"
                                border
                                align="center"
                            >
                                <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >-->
                                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="proofOfEstablishmentName"
                                    label="活动图片"
                                >
                                    <template slot-scope="scope">
                                        <img :src="scope.row.photo" alt width="100%" />
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="proofOfEstablishmentType"
                                    label="活动标题"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="proofOfEstablishmentType"
                                    label="排序"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="proofOfEstablishmentType"
                                    label="上报人"
                                ></el-table-column>
                                <el-table-column align="center" prop="releaseDate" label="发布时间"></el-table-column>
                                <el-table-column
                                    align="center"
                                    label="操作"
                                    width="300"
                                    fixed="right"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-bianji3 tabBtn"
                                                @click="showDialogForm(scope.row.id,'edit')"
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-chakan tabBtn"
                                                @click="showDialogForm(scope.row.id,'detail')"
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-icon7 tabBtn"
                                                @click="showdeletepanduan(scope.row.id)"
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="审批"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-shenhe tabBtn"
                                                style="color:#ff008a"
                                                @click="showbillClick(scope.$index,scope.row)"
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                :page-size="pageConfig.pageSize"
                                layout="total, prev, pager, next, jumper"
                                @current-change="handleCurrentChange"
                                :total="pageConfig.total"
                            ></el-pagination>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <!-- 弹出框 -->
        <!-- 弹出框新增 -->
        <el-dialog
            :title="dialog.title"
            :visible.sync="dialog.off"
            width="1000px"
            :before-close="clearadddata"
        >
            <el-form label-position="right" label-width="140px" :model="dialog.form">
                <el-form-item label="上传图片:">
                    <div class="threestyleimg">
                        <div class="threestyleimgtu">
                            <img :src="eddimgurl" alt style="width:170px;height:150px" />
                        </div>
                        <div class="threestyleimgbtn">
                            <div>上传照片</div>
                            <input type="file" @change="upimg" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="活动标题:">
                    <el-input
                        size="mini"
                        style="width:50%"
                        placeholder="请输入内容"
                        v-model="dialog.form.title"
                    ></el-input>
                </el-form-item>
                <el-form-item label="上报人:">
                    <el-input
                        size="mini"
                        style="width:50%"
                        placeholder="请输入内容"
                        v-model="dialog.form.name"
                    ></el-input>
                </el-form-item>
                <el-form-item label="发布到:">
                    <el-checkbox-group v-model="dialog.form.type">
                        <el-checkbox label="官网">官网</el-checkbox>
                        <el-checkbox label="微信公众号">微信公众号</el-checkbox>
                        <el-checkbox label="APP">APP</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="内容:" style="margin-bottom: 120px">
                    <quillEditor
                        v-model="dialog.form.content"
                        :options="editorOption"
                        style="height:300px"
                    ></quillEditor>
                </el-form-item>

                <el-form-item label="展示排序:">
                    <el-input
                        type="number"
                        style="width:50%"
                        placeholder="请输入内容"
                        v-model="dialog.form.sort"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="boontbtn">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                >{{dialog.btnName}}</el-button>
                <el-button type="info" size="small" @click="clearadddata">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import request from "../../../utils/request.js";
let token = JSON.parse(window.localStorage.getItem("user"));
import { uploadPartyPhoto } from "../../../api/http";
import { quillEditor } from "vue-quill-editor";
export default {
    // components: { ViewMap},
    components: {
        quillEditor
    },
    data() {
        return {
            dialog: {
                form: {
                    type: []
                },
                off: false,
                title: "新增",
                btnName: "上报"
            },
            rules: {
                proofOfEstablishmentType: [
                    { required: true, message: "请选类型", trigger: "blur" }
                ],
                proofOfEstablishmentName: [
                    { required: true, message: "请输入名称", trigger: "blur" }
                ],
                releaseDate: [
                    {
                        required: true,
                        message: "请选择发布时间",
                        trigger: "blur"
                    }
                ],
                status: [
                    {
                        required: true,
                        message: "请选择发布状态",
                        trigger: "blur"
                    }
                ]
            },
            uploadUrl: request.baseURL + "/oneStopUpload/info/uplodfiles",
            // 查询
            searchlist: {},
            tableData: [],
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1
            },
            // 富文本配置
            editorOption: {
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"], // toggled buttons
                        ["blockquote", "code-block"],

                        [{ header: 1 }, { header: 2 }], // custom button values
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ script: "sub" }, { script: "super" }], // superscript/subscript
                        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                        [{ direction: "rtl" }], // text direction

                        [{ size: ["small", false, "large", "huge"] }], // custom dropdown
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],

                        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                        [{ font: [] }],
                        [{ align: [] }],
                        ["image"],
                        ["clean"] // remove formatting button
                    ]
                }
            },
            eddimgurl: require("../../../assets/images/partyMemberManagementcopy/imgjia.png")
        };
    },
    methods: {
        //条件查询
        searchlistdata() {
            this.pageConfig.pageNo = 1;
            this.getPageDatas();
        },
        searchlistReset() {
            this.searchlist = {};
            this.pageConfig.pageNo = 1;
            this.getPageDatas();
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val;
            this.getPageDatas();
        },
        //获取列表数据
        async getPageDatas() {
            let fd = new FormData();
            fd.append("token", token);
            fd.append("pageNo", this.pageConfig.pageNo);
            fd.append("pageSize", this.pageConfig.pageSize);
            let params = JSON.stringify(this.searchlist);
            if (params == "{}") {
                params = '{"status":""}';
            }
            // console.log(params)
            fd.append("findProofOfEstablishment", params);
            var res = await request({
                url: "/proofOfEstablishment/info/listProofOfEstablishment",
                method: "POST",
                data: fd
            });
            if (res.code == 200) {
                this.pageConfig.total = res.content.count;
                this.tableData = res.content.list;
            } else {
                console.log(res);
                this.$message({
                    message: "数据加载异常：",
                    type: "error"
                });
            }
        },
        //删除操作
        async showdeletepanduan(id) {
            this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    let fd = new FormData();
                    fd.append("token", token);
                    fd.append("id", id);
                    var res = await request({
                        url:
                            "/proofOfEstablishment/info/deleteProofOfEstablishment",
                        method: "POST",
                        data: fd
                    });
                    if (res.code == 200) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.showadd = false;
                        this.pageConfig.pageNo = 1;
                        this.getPageDatas();
                    } else {
                        console.log(res);
                        this.$message({
                            message: "删除失败：" + res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        //清空增加的信息
        clearadddata() {
            this.dialog.off = false;
        },
        //保存
        async saveadddata() {
            this.$set(this.tanchuadd, "photo", this.eddimgurl);
            this.$set(this.tanchuadd, "auditStatus", "0");
            let res = await insertPartyPublicity({
                token: getAuthor(),
                tanchuadd: this.tanchuadd
            });
            if (res.code == 200) {
                this.$message({
                    message: res.message,
                    type: "success"
                });
                this.tanchuadd = {};
                this.eddimgurl = require("../../../assets/images/partyMemberManagementcopy/imgjia.png");
                this.showadd = false;
                this.getPartyList();
            } else {
                this.$message({
                    message: "新增失败",
                    type: "error"
                });
            }
        },
        //上传图片
        async upimg(e) {
            let res = await uploadPartyPhoto(e.target.files[0]);
            this.eddimgurl = res.content;
            console.log(res.content);
            this.dialog.form.photo = this.ediimgurl;
        },
        showDialogForm(id, type) {
            this.dialog.off = true;
        }
    },
    mounted() {
        // 初始化数据
        this.getPageDatas();
    }
};
</script>

<style lang="less" scoped>
.organizationalDevelopment {
    background-color: #eef1f6;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    min-width: 1381px;
}
// 面包屑导航box
.mianbao {
    box-sizing: border-box;
    margin: -16px -16px 0;
    background-color: #fff;
    height: 47px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    margin-bottom: 16px;
}
//  包裹两个卡片的盒子
.card-box {
    display: flex;
    // 右边卡片
    .card-rb {
        // width: calc(100% - 270px);
        width: 100%;
    }
}
.card-4 {
    width: 100%;
    // height: 320px;
    padding-left: 16px;
    box-sizing: border-box;
}
// 表格的盒子
.table_card {
    // overflow: hidden;
    // 解决表格无法自适应宽度
    // width: calc(100vw - 500px);
    margin: 16px 0 0 0;
    .el-table {
        width: 100%;
        // 表格里的按钮
        .tabBtn {
            margin: 0 6px;
        }
        .tabBtn:nth-child(1) {
            color: #199b5d;
            font-size: 22px;
        }
        .tabBtn:nth-child(2) {
            color: #ff04ed;
            // font-size: 25px;
        }
        .tabBtn:nth-child(3) {
            color: #dd3020;
            // font-size: 25px;
        }
        .tabBtn:nth-child(5) {
            color: #e400ff;
            font-size: 22px;
        }
        .tabBtn:nth-child(4) {
            color: #2e99cf;
            // font-size: 25px;
        }
        .active_Btn {
            color: #ff04ed !important;
            // font-size: 25px;
        }
    }
}
.active_tab {
    color: #cd2b20 !important;
}
.active_tab1 {
    color: #0f7ef1 !important;
}
.active_tab2 {
    color: #1a9c5e !important;
}

.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
</style>
<style lang="less">
.main[data-v-336d350d] {
    min-width: 1578px !important ;
}
.organizationalDevelopment {
    .el-form--inline .el-form-item {
        display: inline-block;
        margin-right: 10px !important ;
        vertical-align: top;
    }
    .organizationalDevelopment .el-form--inline .el-form-item {
        display: inline-block;
        margin-right: 10px !important ;
        vertical-align: top;
    }
    .el-dialog__header {
        height: 40px;
        padding: 1px;
        background-color: #01aaef;
    }
    .el-dialog__headerbtn {
        position: absolute;
        top: 8px;
        right: 20px;
        padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 24px;
    }
    .el-dialog__title {
        display: block;
        margin-top: 9px;
        margin-left: 10px;
        color: #fff;
        font-size: 15px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
    }
}

.threestyleimg {
    display: flex;
    // align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
    .threestyleimgtu {
        width: 80%;
        height: 70%;
        // background-color: red;
        display: flex;
        // justify-content: center;
        // align-items: center;
    }
    .threestyleimgbtn {
        width: 80%;
        height: 30%;
        margin-top: 20px;

        // background-color: green;
        display: flex;
        // justify-content: center;
        // align-items: center;

        position: relative;
        div {
            width: 170px;
            height: 30%;
            background: #ffffff;
            border: 1px solid #cad4dc;
            text-align: center;
            line-height: 30px;
        }
        input {
            position: absolute;
            width: 172px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
        }
    }
}
</style>